module.exports = __webpack_public_path__ + "img/move.651c83dd.svg";